// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__15_3q","title":"ClientReferral_title__2-Rsd","itemText":"ClientReferral_itemText__22H09"};